/* チェックボックス */
import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import Messages from '../molecules/Messages';
import { KeyValue } from '../types/KeyValue';

interface Props {
  id: string;
  value: string[];
  label: string;
  need?: boolean;
  sources: Array<KeyValue>;
  name: string;
  handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleBlur?: () => void;
  message?: string;
  help_msg?: string;
  disabled: boolean;
}

const CheckBox: React.FC<Props> = ({
  id,
  value,
  label,
  need,
  sources,
  name,
  message,
  help_msg,
  disabled,
  handleChange,
  handleBlur,
}) => {
  return (
    <RowTemplate
      label={label}
      need={need}
      disabled={disabled}
      content={
        <>
          <InputGroup>
            {sources.map((src, index) => {
              return (
                <label className="check-box-label" key={src.key}>
                  <Form.Check
                    disabled={disabled}
                    id={`${id}-${index}`}
                    type="checkbox"
                    inline
                    value={src.key}
                    name={name}
                    defaultChecked={value.includes(src.key)}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="check-box"
                  />
                  {src.value}
                </label>
              );
            })}
          </InputGroup>
          {disabled || <Messages help_msg={help_msg} valid_msg={message} />}
        </>
      }
    />
  );
};

export default CheckBox;
